import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;
export const TIER_PERKS_KEY = ['tier-perks'];

// Super-admin-edited perk wording; null until loaded (callers fall back to built-in copy).
export function useTierPerks() {
  const { user } = useAuth();
  const { data } = useQuery({
    queryKey: TIER_PERKS_KEY,
    queryFn: () => axios.get(`${API_URL}/api/tier-perks`, { withCredentials: true }).then((r) => r.data.perks),
    enabled: !!user,
    staleTime: 5 * 60 * 1000,
  });
  return data || null;
}
